import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sercret-soul-stones',
  templateUrl: './sercret-soul-stones.component.html',
  styleUrls: ['./sercret-soul-stones.component.css']
})
export class SercretSoulStonesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
